<template>
    <span style="display: inline-block;" :class="isFindPositionPro ? 'pro' : 'lite'">{{ position }}</span>
</template>

<script>
export default {
    name: 'DivisionPositionText',
    props: {
        position: {
            type: String,
            defualt: ''
        },
        positionProAbility: {
            type: String,
            default: ''
        }
    },
    computed: {
        isFindPositionPro() {
            if (this.positionProAbility) {
                return true
            } else {
                return false
            }
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style scoped>
.pro {
    background: linear-gradient(180deg, #1370AF 20%, #43CDFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.lite {
    color: var(--color-main)
}
</style>